import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NoteUserView, SearchUsersParameters } from '@api-proxies';
import { UserService } from '@http/clients/user.service';
import { NoteUser } from '@models/NoteUser';
import { EditorComponentBase, GenericTypeAheadMultiselectComponent } from 'ngx-lib';
import { CustomMenuItemComponent } from '../../custom-menu-item/custom-menu-item.component';

@Component({
    selector: 'app-note-user-editor',
    templateUrl: './note-user-editor.component.html',
    styleUrls: ['./note-user-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadMultiselectComponent, CustomMenuItemComponent]
})
export class NoteUserEditorComponent extends EditorComponentBase<NoteUserView[] | undefined> implements OnInit {
    userItems?: NoteUser[];

    selectedUsers?: NoteUser[];

    constructor(private readonly userService: UserService) {
        super();
    }

    ngOnInit(): void {
        if (this.bindingProperty) {
            const mappedResults = this.bindingProperty.map((x) => NoteUser.fromInterface(x));
            this.selectedUsers = mappedResults?.filter((user) => user.userExternalId);
        }
    }

    async onUserTextChange(event: string) {
        const results = await this.userService?.search({
            filterText: event,
            excludeLoggedUser: true,
            isActive: true
        } as SearchUsersParameters);

        this.userItems = results.map((x) => NoteUser.fromUserView(x));
    }

    onSelectedUserChange(event: NoteUser[]) {
        this.bindingProperty = this.selectedUsers = event;
    }

    onRemoveUserChange() {
        if (this.bindingProperty) {
            this.bindingProperty = this.selectedUsers;
        }
    }
}
